import ShopBasketItemsListResourceModel from '../../generated/types/model/resource/ShopBasketItemsListResourceModel';

export default class ShopBasketItemsListResourceViewModel extends ShopBasketItemsListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
